module.exports = __webpack_public_path__ + "img/9788952212290.57698630.jpg";